import React, { useEffect, useState } from 'react';
import axios from 'axios';
import { Link } from 'react-router-dom';

const API_URL = `${process.env.REACT_APP_VENDOR_DOMAIN}/api/services`;

export default function ServicesCRUD() {
  const [services, setServices] = useState([]);
  const [newService, setNewService] = useState({ name: '', description: '' });
  const [editService, setEditService] = useState(null);

  const fetchServices = async () => {
    try {
      const res = await axios.get(API_URL);
      setServices(res.data);
    } catch (err) {
      console.error('Error fetching services:', err);
    }
  };

  useEffect(() => {
    fetchServices();
  }, []);

  const handleCreate = async () => {
    if (!newService.name.trim() || !newService.description.trim()) return;
    try {
      await axios.post(API_URL, newService);
      setNewService({ name: '', description: '' });
      fetchServices();
    } catch (err) {
      console.error('Error creating service:', err);
    }
  };

  const handleUpdate = async (id) => {
    try {
      await axios.put(`${API_URL}/${id}`, editService);
      setEditService(null);
      fetchServices();
    } catch (err) {
      console.error('Error updating service:', err);
    }
  };

  const handleDelete = async (id) => {
    try {
      await axios.delete(`${API_URL}/${id}`);
      fetchServices();
    } catch (err) {
      console.error('Error deleting service:', err);
    }
  };

  return (
    <div className="container my-5">
      <h2 className="text-center mb-4" style={styles.header}>DIY Services Manager</h2>

      {/* Create New Service Card */}
      <div className="card shadow-sm mb-4" style={styles.createCard}>
        <div className="card-body">
          <h5 className="card-title" style={styles.cardTitle}>Create New Service</h5>
          <div className="row g-2">
            <div className="col-md">
              <input
                type="text"
                placeholder="Service Name"
                value={newService.name}
                onChange={(e) =>
                  setNewService({ ...newService, name: e.target.value })
                }
                className="form-control"
                style={styles.input}
              />
            </div>
            <div className="col-md">
              <input
                type="text"
                placeholder="Description"
                value={newService.description}
                onChange={(e) =>
                  setNewService({ ...newService, description: e.target.value })
                }
                className="form-control"
                style={styles.input}
              />
            </div>
            <div className="col-md">
              <input
                type="text"
                placeholder="Image URL"
                value={newService.image_url || ''}
                onChange={(e) =>
                  setNewService({ ...newService, image_url: e.target.value })
                }
                className="form-control"
                style={styles.input}
              />
            </div>
            <div className="col-md-auto">
              <button onClick={handleCreate} className="btn btn-primary w-100" style={styles.addButton}>
                Add
              </button>
            </div>
          </div>
        </div>
      </div>

      {/* Services List */}
      {services.length > 0 ? (
        <div className="row g-4">
          {services.map((service) => (
            <div key={service.id} className="col-sm-6 col-md-4">
              <div className="card h-100 shadow-sm" style={styles.serviceCard}>
                <div className="card-body">
                  {editService?.id === service.id ? (
                    <>
                      <input
                        className="form-control mb-2"
                        value={editService.name}
                        onChange={(e) =>
                          setEditService({
                            ...editService,
                            name: e.target.value,
                          })
                        }
                        style={styles.input}
                      />
                      <textarea
                        className="form-control mb-3"
                        value={editService.description}
                        onChange={(e) =>
                          setEditService({
                            ...editService,
                            description: e.target.value,
                          })
                        }
                        style={styles.input}
                      />
                      <input
                        className="form-control mb-3"
                        value={editService.image_url || ''}
                        onChange={(e) =>
                          setEditService({
                            ...editService,
                            image_url: e.target.value,
                          })
                        }
                        style={styles.input}
                        placeholder="Image URL"
                      />
                      <div className="d-flex gap-2">
                        <button
                          onClick={() => handleUpdate(service.id)}
                          className="btn btn-success btn-sm"
                        >
                          Save
                        </button>
                        <button
                          onClick={() => setEditService(null)}
                          className="btn btn-secondary btn-sm"
                        >
                          Cancel
                        </button>
                      </div>
                    </>
                  ) : (
                    <>
                      <h5 className="card-title" style={styles.cardTitle}>
                        <Link
                          to={`/services_details/${service.id}`}
                          className="text-decoration-none"
                          style={styles.link}
                        >
                          {service.name}
                        </Link>
                      </h5>
                      {service.image_url && (
                        <img
                          src={service.image_url}
                          alt={service.name}
                          className="img-fluid mb-3"
                          style={{
                            maxHeight: '120px',
                            objectFit: 'cover',
                            borderRadius: '6px',
                            display: 'block',
                            margin: '12px 0 0 0',
                          }}
                        />
                      )}
                      <p className="card-text text-muted" style={styles.description}>
                        {service.description}
                      </p>
                      <div className="d-flex flex-wrap gap-3 mt-2">
                        {service.creation_date && (
                          <span className="card-text text-muted" style={{ fontSize: '0.95rem' }}>
                            <strong>Created:</strong> {new Date(service.creation_date).toLocaleString()}
                          </span>
                        )}
                        {service.modification_date && (
                          <span className="card-text text-muted" style={{ fontSize: '0.95rem' }}>
                            <strong>Last Modified:</strong> {new Date(service.modification_date).toLocaleString()}
                          </span>
                        )}
                      </div>
                      <div className="d-flex gap-2">
                        <button
                          onClick={() => setEditService(service)}
                          className="btn btn-warning btn-sm text-white"
                        >
                          Edit
                        </button>
                        <button
                          onClick={() => handleDelete(service.id)}
                          className="btn btn-danger btn-sm"
                        >
                          Delete
                        </button>
                      </div>
                    </>
                  )}
                </div>
              </div>
            </div>
          ))}
        </div>
      ) : (
        <p className="text-center text-muted mt-4" style={styles.noServices}>No services found.</p>
      )}
    </div>
  );
}

const styles = {
  header: {
    color: '#4078c0',
    fontWeight: 700,
    letterSpacing: '1px',
  },
  createCard: {
    background: '#f5f6fa',
    borderRadius: '12px',
    border: 'none',
  },
  cardTitle: {
    color: '#4078c0',
    fontWeight: 600,
    fontSize: '1.25rem',
    marginBottom: '12px',
  },
  input: {
    borderRadius: '6px',
    fontSize: '1rem',
  },
  addButton: {
    fontWeight: 600,
    borderRadius: '6px',
  },
  serviceCard: {
    borderRadius: '12px',
    border: 'none',
    background: '#fff',
  },
  link: {
    color: '#4078c0',
    fontWeight: 600,
    fontSize: '1.1rem',
    textDecoration: 'none',
  },
  description: {
    fontSize: '1rem',
    color: '#555',
    marginBottom: '12px',
  },
  noServices: {
    fontSize: '1.1rem',
    color: '#777',
  },
};